import { render, staticRenderFns } from "./image_menu.vue?vue&type=template&id=fdd0846c&scoped=true"
import script from "./image_menu.vue?vue&type=script&lang=js"
export * from "./image_menu.vue?vue&type=script&lang=js"
import style0 from "./image_menu.vue?vue&type=style&index=0&id=fdd0846c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd0846c",
  null
  
)

export default component.exports